import axios from "axios";

//https://api.happyplants.me
//https://apiplants.amark.pro
let urlAPI = "https://apiplants.amark.pro";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

// Официальный партнёр в ЕС: онлайн-заказы на сайте оформляются только на Молдову,
// покупатели из ЕС уходят на сайт партнёра.
let partnerURL = "https://gartenlux.de";

export { urlAPI, partnerURL, axiosInstance };
